import { Contract } from "src/app/public/account/models/contract.model";
import { Dealer } from "src/app/public/account/models/dealer.model";
import { RatingsSummary } from "src/app/public/account/models/ratings-summary";
import { ReviewReply } from "src/app/public/account/models/review-reply.model";
import { Proposal } from "src/app/public/buy/models/proposal.model";
import { CarStatus, CarBusinessLine } from "src/app/public/car/constants/car-basic-data";
import { Alert } from "src/app/public/car/models/alert.model";
import { CarBrief } from "src/app/public/car/models/car-brief.model";
import { Car } from "src/app/public/car/models/car.model";
import { ObjectClass } from "src/app/public/common/constants/common-basic-data";
import { Appointment } from "src/app/public/common/models/appointment.model";
import { Conversation } from "src/app/public/common/models/conversation.model";
import { Message } from "src/app/public/common/models/message.model";
import { Price, Offer } from "src/app/public/common/models/string-data.model";
import { Job } from "src/app/public/keep/models/job.model";

import { Posting } from "src/app/public/keep/models/posting.model";
import { KeepOffer } from "src/app/public/keep/models/keep-offer.model";
import { Booking } from "src/app/public/rent/models/booking.model";


export class DealerStoreUtils{

    // car

    public static addCar = ( cars: Car[], newCar: Car ) => [...cars, newCar];

    public static updateCar = ( cars: Car[],  changes: Car ) => 
        cars.map ( car => {
            return car.carId === changes.carId 
                ? Object.assign({}, car, changes)
                : car ;
        });
        
    public static deleteCar = ( cars: Car[], carId: string ) =>  cars.filter(car => carId !== car.carId);

    public static updateCarStatus = ( cars: Car[],  carId: string, status: CarStatus ) => {

        let updatedCars: Car[]  = JSON.parse(JSON.stringify(cars));
    
        let index = updatedCars.findIndex(car => carId === car.carId)!;
        
        if(index >= 0){
            updatedCars[index].status = status;
            return updatedCars;
        }
    
        return updatedCars;
    }

    public static upsertProviderOffer = ( cars: Car[],  updatedOffer: Car) => {
        
        let tempCars: Car[] = JSON.parse(JSON.stringify(cars));

        let offerIndex = tempCars.findIndex(item => item.offerId === updatedOffer.offerId)!;

        if(offerIndex >= 0 ){
            tempCars.splice(offerIndex, 1, updatedOffer);
        }  
        else{
            if( tempCars == undefined){
                tempCars = [];
            }
            tempCars.push(updatedOffer); 
        } 
        
        return tempCars;

    }

    public static upsertProviderOfferInPark = ( cars: Car[],  updatedOffer: Car) => {
        
        let tempCars: Car[] = JSON.parse(JSON.stringify(cars));

        let carIndex = tempCars.findIndex(item => item.carId === updatedOffer.carId)!;

        if(! (carIndex >= 0)){
            return tempCars;
        }

        switch(updatedOffer.businessLine){

            case CarBusinessLine.BUY: {

                let offerIndex = tempCars[carIndex].buyOffers.findIndex(item => item.offerId === updatedOffer.offerId)!;

                if(offerIndex >= 0 ){
                    tempCars[carIndex].buyOffers.splice(offerIndex, 1, updatedOffer);
                }  
                else{
                    if( tempCars[carIndex].buyOffers == undefined){
                        tempCars[carIndex].buyOffers = [];
                    }
                    tempCars[carIndex].buyOffers.push(updatedOffer); 
                } 
                
                return tempCars;

            }

            case CarBusinessLine.RENT: {

                let offerIndex = tempCars[carIndex].rentOffers.findIndex(item => item.offerId === updatedOffer.offerId)!;

                if(offerIndex >= 0 ){
                    tempCars[carIndex].rentOffers.splice(offerIndex, 1, updatedOffer);
                }  
                else{
                    if( tempCars[carIndex].rentOffers == undefined){
                        tempCars[carIndex].rentOffers = [];
                    }
                    tempCars[carIndex].rentOffers.push(updatedOffer); 
                } 
                
                return tempCars;
                
            }
            default:{
                return tempCars;
            }
        }
    }


    public static upsertKeepOfferInDealer = ( dealer: Dealer,  offer: KeepOffer) => {
        
        let temp: Dealer = JSON.parse(JSON.stringify(dealer));

        temp.keepOffer = offer;
        return temp;

    }


    public static deleteProviderOffer = ( cars: Car[], offerId: string) => {
        
        let tempCars: Car[] = JSON.parse(JSON.stringify(cars));

        return tempCars.filter(item => item.offerId !== offerId)

    }

    public static deleteProviderOfferInPark = ( cars: Car[], carId: string, offerId: string, businessLine: CarBusinessLine) => {
        
        let tempCars: Car[] = JSON.parse(JSON.stringify(cars));

        let carIndex = tempCars.findIndex(item => item.carId === carId)!;

        if(! (carIndex >= 0)){
            return tempCars;
        }

        switch(businessLine){

            case CarBusinessLine.BUY: {

                let offerIndex = tempCars[carIndex].buyOffers.findIndex(item => item.offerId === offerId)!;

                tempCars[carIndex].buyOffers.splice(offerIndex, 1);

                return tempCars;

            }

            case CarBusinessLine.RENT: {

                let offerIndex = tempCars[carIndex].rentOffers.findIndex(item => item.offerId === offerId)!;

                tempCars[carIndex].rentOffers.splice(offerIndex, 1);
                
                return tempCars;
                
            }
            default:{
                return tempCars;
            }
        }
    }

    public static addCarImageFilename = ( cars: Car[],  carId: string, imageFilename: string ) => {
        return cars.map ( car => {
            let temp = Object.assign({}, car)
            if(temp.carId === carId) {
                console.log("adding images to car id = "+temp.carId );
                temp.imagesFilenames = [];
                temp.imagesFilenames.push(imageFilename);
            }
            return temp;
        });
    }

        // car price

        public static addCarPrice = ( cars: Car[], carId: string, businessLine: CarBusinessLine, newPrice: Price ) => {

            let updatedCar: Car  = JSON.parse(JSON.stringify(cars.find(car => carId === car.carId)!));
    
            switch ( businessLine.toString() ) {
    
                case CarBusinessLine.BUY.toString(): {
                    if(updatedCar.buyPriceHistory == undefined){
                        updatedCar.buyPriceHistory = [];
                    }
                    updatedCar.buyPriceHistory.push(newPrice);
                    updatedCar.buyPrice = newPrice;
                    break;
                }
                    
                case CarBusinessLine.RENT.toString(): {
                    if(updatedCar.rentDayRateHistory == undefined){
                        updatedCar.rentDayRateHistory = [];
                    }
                    updatedCar.rentDayRateHistory.push(newPrice);
                    updatedCar.rentDayRate = newPrice;
                    break;
                }
    
                default: 
                    // 
                    break;
             }
    
    
            return this.updateCar (cars, updatedCar);
        }
    
        // car offers
    
        public static addCarOffer = ( cars: Car[],  carId: string, newOffer: Offer ) => {
    
            let updatedCar: Car  = JSON.parse(JSON.stringify(cars.find(car => carId === car.carId)!));
            
            if(updatedCar.offers == undefined){
                updatedCar.offers = [];
            }
            updatedCar.offers.push(newOffer);
    
            return this.updateCar (cars, updatedCar);
        }
    
    // basket

    public static updateCarBasket = ( carBasket: Map<string, Array<Car>>,  bizLine: CarBusinessLine, updatedCars: Car[]  ) => {
        
       console.log(updatedCars);
       console.log(bizLine);
       //console.log(carBasket.entries());
        if(carBasket == undefined){
            console.log("basket empty")
            return
        }

        //let tempBask: Map<string, Array<Car>> = new Map([]);  
        let tempBask : Map<string, Array<Car>>= Object.assign(new Map([]), carBasket);
        
        tempBask.set(bizLine.toString(), updatedCars);

        return tempBask;

        if (carBasket!.has(bizLine.toString())){

            let tempBasket = new Map(carBasket);

            tempBasket.set(bizLine, updatedCars);

            console.log('basket for bizline '+bizLine+ 'after insert = '+tempBasket.get(bizLine.toString())!);
            
            return tempBasket;

        }
        else {
            //console.log('imagesFolders map has not before = '+imagesFolders.get(carId)?.length);
            let tempBasket = new Map(carBasket);
            //console.log('during = '+temp.get(carId)?.length);
            tempBasket.set(bizLine, updatedCars);
            //console.log('after = '+temp.get(carId)?.length);

            console.log('basket for bizline '+bizLine+ 'after creation = '+tempBasket.get(bizLine)!);
    
            return tempBasket;

        }

        //let temp: Map<string, Blob[]> = Object.assign({}, imagesFolders);
       
    }
    
    
    public static toggleFavoriteOld = ( cars: Car[],  carId: string, makeFav: boolean ) => {
        let temp = JSON.parse(JSON.stringify(cars));
        console.log(temp);
        if(makeFav){
            if(temp.carFavorites == undefined){
                temp.carFavorites = [];
            }
            temp.carFavorites.push(carId);
        }
        else{
            const index = temp.carFavorites.indexOf(carId, 0);
            if (index > -1) {
                temp.carFavorites.splice(index, 1);
            }
        }
        return temp;
    }

    public static addFavorite = ( cars: Car[],  car: Car) => {
        let temp = JSON.parse(JSON.stringify(cars));
       
        if(temp == undefined){
            temp = [];
        }
        temp.push(car);
        
        return temp;
    }

    public static removeFavorite = ( cars: Car[],  carId: string) => {
        let temp = JSON.parse(JSON.stringify(cars));
        
        const index = temp.findIndex((car: Car) => car.carId === carId)
        if (index > -1) {
            temp.splice(index, 1);
        }
        
        return temp;
    }

    public static toggleCarFavorite = ( cars: CarBrief[] | Car[] ,  carId: string, makeFav: boolean) => {

        let temp = JSON.parse(JSON.stringify(cars));
        
        const index = temp.findIndex((car: Car) => car.carId === carId)
        if (index > -1) {
            temp[index].favorite = makeFav;
        }
        return temp;
    }

    public static toggleFavorite = ( cars: CarBrief[] | Car[], objectId: string, objectClass: ObjectClass, makeFav: boolean) => {

        let temp = JSON.parse(JSON.stringify(cars));

        switch(objectClass){

            case ObjectClass.CAR:{
                const index = temp.findIndex((car: Car) => car.carId === objectId)
                if (index > -1) {
                    temp[index].favorite = makeFav;
                }
                return temp;
            }

            case ObjectClass.OFFER:{
                const index = temp.findIndex((car: Car) => car.offerId === objectId)
                if (index > -1) {
                    temp[index].favorite = makeFav;
                }
                return temp;
            }
        }  
    }

    public static toggleBusinessLineStatus = ( cars: Car[],  carId: string, status: boolean, businessLine: CarBusinessLine ) => {

        let updatedCars: Car[]  = JSON.parse(JSON.stringify(cars));

        let carIndex = updatedCars.findIndex(car => carId === car.carId)!;

        if(! (carIndex >= 0)){
            return updatedCars;
        }

        switch ( businessLine.toString() ) {
            case CarBusinessLine.BUY.toString():
                //updatedCars[carIndex].buyActiveHistory.push(status);
                updatedCars[carIndex].buyActive = status;
                break;
            case CarBusinessLine.RENT.toString():
                //updatedCars[carIndex].rentActiveHistory.push(status);
                updatedCars[carIndex].rentActive = status;
                break;
            default: 
                // 
                break;
         }

        return updatedCars;
    }

    public static toggleFavoriteProvider = ( dealer: Dealer,  providerId: string, makeFav: boolean ) => {

        let dl: Dealer  = JSON.parse(JSON.stringify(dealer));

        let pvIndex = dl.favoriteProviderIds.findIndex(fav => providerId === fav)!;

        if(pvIndex >= 0){  // id found
            if(!makeFav){
                dl.favoriteProviderIds.splice(pvIndex);
                return dl;
            }
        } else{ // not found
            if(makeFav){
                dl.favoriteProviderIds.push(providerId);
                return dl;
            }
        }

        return dl;

    }

    // alerts

    public static addAlert = ( dealer: Dealer,  alert: Alert ) => {
        let temp = JSON.parse(JSON.stringify(dealer));

        if(temp.alerts == undefined){
            temp.alerts = [];
        }
        temp.alerts.push(alert);
        return temp;
    }

    public static updateAlert = ( dealer: Dealer, alert: Alert ) => {
        
        let temp: Dealer = JSON.parse(JSON.stringify(dealer));

        let index = temp.alerts.findIndex(alrt => alrt.id === alert.id)!;

        temp.alerts.splice(index, 1, alert);
        
        return temp;
    }

    public static deleteAlert = ( dealer: Dealer,  alertId: number ) => {
        
        let temp: Dealer = JSON.parse(JSON.stringify(dealer));

        let index = temp.alerts.findIndex(alrt => alrt.id === alertId)!;

        temp.alerts.splice(index, 1);

        return temp;
    }

    public static setAlerts = ( dealer: Dealer,  alerts: Alert[] ) => {
        let temp = JSON.parse(JSON.stringify(dealer));

        if(temp.alerts == undefined){
            temp.alerts = [];
        }
        temp.alerts = alerts;
        return temp;
    }

    public static addAlertInDealer = ( dealerData: Dealer,  alert: Alert ) => {
        let temp = JSON.parse(JSON.stringify(dealerData));

        if(temp.alerts == undefined){
            temp.alerts = [];
        }
        temp.alerts.push(alert);
        return temp;
    }

    public static updateAlertInDealer = ( dealerData: Dealer, alert: Alert ) => {
        
        let temp: Dealer = JSON.parse(JSON.stringify(dealerData));

        let index = temp.alerts.findIndex(alrt => alrt.id === alert.id)!;

        temp.alerts.splice(index, 1, alert);
        
        return temp;
    }

    public static deleteAlertInDealer = ( dealerData: Dealer,  alertId: number ) => {
        
        let temp: Dealer = JSON.parse(JSON.stringify(dealerData));

        let index = temp.alerts.findIndex(alrt => alrt.id === alertId)!;

        temp.alerts.splice(index, 1);

        return temp;
    }

    public static setAlertsInDealer = ( dealerData: Dealer,  alerts: Alert[] ) => {
        let temp = JSON.parse(JSON.stringify(dealerData));

        if(temp.alerts == undefined){
            temp.alerts = [];
        }
        temp.alerts = alerts;
        return temp;
    }

    //proposals

    public static addProposalOld = ( cars: Car[], carId: string, proposal: Proposal ) => {

        let updatedCars: Car[]  = JSON.parse(JSON.stringify(cars));

        let carIndex = updatedCars.findIndex(car => carId === car.carId)!;

        if(! (carIndex >= 0)){
            return updatedCars;
        }

        if( updatedCars[carIndex].proposals == undefined){
            updatedCars[carIndex].proposals = [];
        }
        updatedCars[carIndex].proposals.push(proposal);
        return updatedCars;
    }

    public static updateProposalOld = ( cars: Car[], carId: string, index: number, proposal: Proposal ) => {
        
        let updatedCars: Car[]  = JSON.parse(JSON.stringify(cars));

        let carIndex = updatedCars.findIndex(car => carId === car.carId)!;

        if(! (carIndex >= 0)){
            return updatedCars;
        }

        updatedCars[carIndex].proposals.splice(index, 1, proposal);
        
        return updatedCars;
    }

    public static addProposal = ( cars: Car[], proposal: Proposal ) => {

        let updatedCars: Car[]  = JSON.parse(JSON.stringify(cars));

        let carIndex = updatedCars.findIndex(car => car.carId === proposal.carId )!;

        if(! (carIndex >= 0)){
            return updatedCars;
        }

        if( updatedCars[carIndex].proposals == undefined){
            updatedCars[carIndex].proposals = [];
        }
        updatedCars[carIndex].proposals.push(proposal);
        return updatedCars;
    }

    public static updateProposal = ( cars: Car[], proposal: Proposal ) => {
        
        let updatedCars: Car[]  = JSON.parse(JSON.stringify(cars));

        let carIndex = updatedCars.findIndex(car =>  car.carId === proposal.carId)!;

        if(! (carIndex >= 0)){
            return updatedCars;
        }

        let propIndex = updatedCars[carIndex].proposals.findIndex(prop => prop.id === proposal.id)!;

        updatedCars[carIndex].proposals.splice(propIndex, 1, proposal);
        
        return updatedCars;
    }

    public static upsertProposalInDealer = ( dealerData: Dealer, proposal: Proposal ) => {
        
        let temp: Dealer = JSON.parse(JSON.stringify(dealerData));

        let index = temp.proposals.findIndex(alrt => alrt.id === proposal.id)!;
        if(index >= 0 ){
            temp.proposals.splice(index, 1, proposal);
        }  
        else{
            if( temp.proposals == undefined){
                temp.proposals = [];
            }
            temp.proposals.push(proposal); 
        } 
        
        return temp;
    }

    public static upsertProposalInCar = ( cars: Car[], proposal: Proposal ) => {
        
        let updatedCars: Car[]  = JSON.parse(JSON.stringify(cars));

        let carIndex = updatedCars.findIndex(car =>  car.carId === proposal.carId)!;

        if(! (carIndex >= 0)){
            return updatedCars;
        }

        let propIndex = updatedCars[carIndex].proposals.findIndex(prop => prop.id === proposal.id)!;

        if(propIndex >= 0){
            updatedCars[carIndex].proposals.splice(propIndex, 1, proposal);
        }
        else{
            if( updatedCars[carIndex].proposals == undefined){
                updatedCars[carIndex].proposals = [];
            }
            updatedCars[carIndex].proposals.push(proposal);
        }
        
        return updatedCars;
    }

    //jobs

    public static addJob = ( cars: Car[], job: Job ) => {

        let updatedCars: Car[]  = JSON.parse(JSON.stringify(cars));

        let carIndex = updatedCars.findIndex(car => car.carId === job.carId )!;

        if(! (carIndex >= 0)){
            return updatedCars;
        }

        if( updatedCars[carIndex].jobs == undefined){
            updatedCars[carIndex].jobs = [];
        }
        updatedCars[carIndex].jobs.push(job);
        return updatedCars;
    }

    public static updateJob = ( cars: Car[], job: Job ) => {
        
        let updatedCars: Car[]  = JSON.parse(JSON.stringify(cars));

        let carIndex = updatedCars.findIndex(car =>  car.carId === job.carId)!;

        if(! (carIndex >= 0)){
            return updatedCars;
        }

        let propIndex = updatedCars[carIndex].jobs.findIndex(prop => prop.jobId === job.jobId)!;

        updatedCars[carIndex].jobs.splice(propIndex, 1, job);
        
        return updatedCars;
    }

       //appointments

       public static addAppointmentInCarOld = ( cars: Car[], appointment: Appointment ) => {

        let updatedCars: Car[]  = JSON.parse(JSON.stringify(cars));

        let carIndex = updatedCars.findIndex(car => car.carId === appointment.carId )!;

        if(! (carIndex >= 0)){
            return updatedCars;
        }

        if( updatedCars[carIndex].appointments == undefined){
            updatedCars[carIndex].appointments = [];
        }
        updatedCars[carIndex].appointments.push(appointment);
        return updatedCars;
    }

    public static updateAppointmentInCarOld = ( cars: Car[], appointment: Appointment ) => {
        
        let updatedCars: Car[]  = JSON.parse(JSON.stringify(cars));

        let carIndex = updatedCars.findIndex(car =>  car.carId === appointment.carId)!;

        if(! (carIndex >= 0)){
            return updatedCars;
        }

        let propIndex = updatedCars[carIndex].appointments.findIndex(prop => prop.id === appointment.id)!;

        updatedCars[carIndex].appointments.splice(propIndex, 1, appointment);
        
        return updatedCars;
    }

    public static upsertAppointmentInCar = ( cars: Car[], appointment: Appointment ) => {
        
        let updatedCars: Car[]  = JSON.parse(JSON.stringify(cars));

        let carIndex = updatedCars.findIndex(car =>  car.carId === appointment.carId)!;

        if(! (carIndex >= 0)){
            return updatedCars;
        }

        let propIndex = updatedCars[carIndex].appointments.findIndex(prop => prop.id === appointment.id)!;

        if(propIndex >= 0){
            updatedCars[carIndex].appointments.splice(propIndex, 1, appointment);
        }
        else{
            if( updatedCars[carIndex].appointments == undefined){
                updatedCars[carIndex].appointments = [];
            }
            updatedCars[carIndex].appointments.push(appointment);
        }
        
        return updatedCars;
    }

    //appointments in dealer data
    /*
    public static addAppointmentInDealer = ( dealerData: Dealer,  appointment: Appointment ) => {
        let temp: Dealer = JSON.parse(JSON.stringify(dealerData));

        if(temp.appointments == undefined){
            temp.appointments = [];
        }
        temp.appointments.push(appointment);
        return temp;
    }
    */ 
    public static upsertAppointmentInDealer = ( dealerData: Dealer, appointment: Appointment ) => {
        
        let temp: Dealer = JSON.parse(JSON.stringify(dealerData));

        let index = temp.appointments.findIndex(alrt => alrt.id === appointment.id)!;
        if(index >= 0 ){
            temp.appointments.splice(index, 1, appointment);
        }  
        else{
            if( temp.appointments == undefined){
                temp.appointments = [];
            }
            temp.appointments.push(appointment); 
        } 
        
        return temp;
    }

    public static deleteAppointmentInDealer = ( dealerData: Dealer,  appointmentId: number ) => {
        
        let temp: Dealer = JSON.parse(JSON.stringify(dealerData));

        let index = temp.appointments.findIndex(appt => appt.id === appointmentId)!;

        temp.appointments.splice(index, 1);

        return temp;
    }

    public static setAppointmentsInDealer = ( dealerData: Dealer,  appointments: Appointment[] ) => {
        let temp: Dealer = JSON.parse(JSON.stringify(dealerData));

        if(temp.appointments == undefined){
            temp.appointments = [];
        }
        temp.appointments = appointments;
        return temp;
    }

    // conversations in dealer data
    public static setConversationsInDealer = ( dealerData: Dealer,  conversations: Conversation[] ) => {
        let temp: Dealer = JSON.parse(JSON.stringify(dealerData));

        if(temp.conversations == undefined){
            temp.conversations = [];
        }
        temp.conversations = conversations;
        return temp;
    }

    public static updateConversationInDealer = ( dealerData: Dealer, conversation: Conversation ) => {
        
        //let temp: Dealer = Object.assign(new Dealer(), dealerData); 
        let temp: Dealer = JSON.parse(JSON.stringify(dealerData));
        let conv: Conversation = Object.assign(new Conversation(), conversation); 

        let index = temp.conversations.findIndex(item => item.id === conversation.id)!;

        temp.conversations.splice(index, 1, conv);
        
        return temp;
    }

    public static updateConversationInCar = ( cars: Car[], conversation: Conversation ) => {
        
        let temp: Car[] = JSON.parse(JSON.stringify(cars));
        let conv: Conversation = Object.assign(new Conversation(), conversation); 

        let carIndex = temp.findIndex(item => item.carId === conversation.carId)!;
        let convIndex = temp[carIndex].conversations.findIndex(item => item.id === conversation.id)!;

        temp[carIndex].conversations.splice(convIndex, 1, conv);
        
        return temp;
    }

    //contracts in dealer data

    /** 

    public static addContractInDealer = ( dealerData: Dealer,  contract: Contract ) => {
        let temp: Dealer = Object.assign(new Dealer(), dealerData);

        if(temp.contracts == undefined){
            temp.contracts = [];
        }
        temp.contracts.push(Object.assign(new Contract(), contract));

        return temp;
    }

    public static updateContractInDealer = ( dealerData: Dealer, contract: Contract ) => {
        
        //let temp: Dealer = Object.assign(new Dealer(), dealerData); 
        let temp: Dealer = JSON.parse(JSON.stringify(dealerData));
        let cntrct: Contract = Object.assign(new Contract(), contract); 

        let index = temp.contracts.findIndex(item => item.contractId === contract.contractId)!;

        temp.contracts.splice(index, 1, cntrct);
        
        return temp;
    }
        */

    public static upsertContractInDealer = ( dealerData: Dealer, contract: Contract ) => {
        
        //let temp: Dealer = Object.assign(new Dealer(), dealerData); 
        let temp: Dealer = JSON.parse(JSON.stringify(dealerData));
        let cntrct: Contract = Object.assign(new Contract(), contract); 

        if(temp.username === contract.customerId) {
            if(temp.customerContracts == undefined){
            temp.customerContracts = [];
            }

            let index = temp.customerContracts.findIndex(item => item.contractId === contract.contractId)!;

            if(index >= 0){
                temp.customerContracts.splice(index, 1, cntrct);
            }
            
            else{
                temp.customerContracts.push(Object.assign(new Contract(), contract));
            }
        }

        if(temp.username === contract.providerId) {
            if(temp.providerContracts == undefined){
                temp.providerContracts = [];
            }

            let index = temp.providerContracts.findIndex(item => item.contractId === contract.contractId)!;

            if(index >= 0){
                temp.providerContracts.splice(index, 1, cntrct);
            }
            
            else{
                temp.providerContracts.push(Object.assign(new Contract(), contract));
            }
        }
        
        return temp;
    }

    public static deleteContractInDealer = ( dealerData: Dealer,  contractId: string ) => {
        
        let temp: Dealer = Object.assign(new Dealer(), dealerData);

        let index = temp.customerContracts.findIndex(appt => appt.contractId === contractId)!;
        temp.customerContracts.splice(index, 1);

        index = temp.providerContracts.findIndex(appt => appt.contractId === contractId)!;
        temp.providerContracts.splice(index, 1);

        return temp;
    }

    public static setContractsInDealer = ( dealerData: Dealer,  contracts: Contract[] ) => {
        let temp: Dealer = Object.assign(new Dealer(), dealerData); 

        if(temp.customerContracts == undefined){
            temp.customerContracts = [];
        }
        if(temp.providerContracts == undefined){
            temp.providerContracts = [];
        }
        temp.customerContracts = [];
        temp.providerContracts = [];

        contracts.forEach( (contract: Contract) => {
            if(dealerData.username === contract.customerId){
                temp.customerContracts.push(Object.assign(new Contract(), contract))
            }

            if(dealerData.username === contract.providerId){
                temp.providerContracts.push(Object.assign(new Contract(), contract))
            }
            
        });

        return temp;
    }

    public static setMyOwnersInDealer = ( dealerData: Dealer,  owners: Dealer[] ) => {
        let temp: Dealer = JSON.parse(JSON.stringify(dealerData));

        if(temp.myOwners == undefined){
            temp.myOwners = [];
        }
        temp.myOwners = owners;
        return temp;
    }

    public static setMyProvidersInDealer = ( dealerData: Dealer,  providers: Dealer[] ) => {
        let temp: Dealer = JSON.parse(JSON.stringify(dealerData));

        if(temp.myProviders == undefined){
            temp.myProviders = [];
        }
        temp.myProviders = providers;
        return temp;
    }


    //bookings

    public static addBookingInCar = ( cars: Car[], booking: Booking ) => {

        let updatedCars: Car[]  = JSON.parse(JSON.stringify(cars));

        let carIndex = updatedCars.findIndex(car => booking.carId === car.carId)!;

        if(! (carIndex >= 0)){
            return updatedCars;
        }

        if( updatedCars[carIndex].myBookings == undefined){
            updatedCars[carIndex].myBookings = [];
        }
        updatedCars[carIndex].myBookings.push(booking);
        return updatedCars;
    }

    public static updateBookingInCar = ( cars: Car[], booking: Booking ) => {

        let updatedCars: Car[]  = JSON.parse(JSON.stringify(cars));

        let carIndex = updatedCars.findIndex(car => booking.carId === car.carId)!;

        if(! (carIndex >= 0)){
            return updatedCars;
        }

        let bookingIndex = updatedCars[carIndex].myBookings.findIndex(bk => bk.id === booking.id)!;

        updatedCars[carIndex].myBookings.splice(bookingIndex, 1, booking);
        
        return updatedCars;
    }

    public static upsertBookingInDealer = ( dealerData: Dealer, booking: Booking ) => {
        
        let temp: Dealer = JSON.parse(JSON.stringify(dealerData));

        let index = temp.bookings.findIndex(alrt => alrt.id === booking.id)!;
        if(index >= 0 ){
            temp.bookings.splice(index, 1, booking);
        }  
        else{
            if( temp.bookings == undefined){
                temp.bookings = [];
            }
            temp.bookings.push(booking); 
        } 
        
        return temp;
    }

    public static upsertBookingInCar = ( cars: Car[], booking: Booking ) => {
        
        let updatedCars: Car[]  = JSON.parse(JSON.stringify(cars));

        let carIndex = updatedCars.findIndex(car =>  car.carId === booking.carId)!;

        if(! (carIndex >= 0)){
            return updatedCars;
        }

        let propIndex = updatedCars[carIndex].myBookings.findIndex(prop => prop.id === booking.id)!;

        if(propIndex >= 0){
            updatedCars[carIndex].myBookings.splice(propIndex, 1, booking);
        }
        else{
            if( updatedCars[carIndex].myBookings == undefined){
                updatedCars[carIndex].myBookings = [];
            }
            updatedCars[carIndex].myBookings.push(booking);
        }
        
        return updatedCars;
    }


    // Jobs

    public static upsertJobInDealer = ( dealerData: Dealer, job: Job ) => {
        
        let temp: Dealer = JSON.parse(JSON.stringify(dealerData));

        let index = temp.jobs.findIndex(jb => jb.jobId === job.jobId)!;
        if(index >= 0 ){
            temp.jobs.splice(index, 1, job);
        }  
        else{
            if( temp.jobs == undefined){
                temp.jobs = [];
            }
            temp.jobs.push(job); 
        } 
        
        return temp;
    }

    public static upsertJobInCar = ( cars: Car[], job: Job ) => {
        
        let updatedCars: Car[]  = JSON.parse(JSON.stringify(cars));

        let carIndex = updatedCars.findIndex(car =>  car.carId === job.carId)!;

        if(! (carIndex >= 0)){
            return updatedCars;
        }

        let propIndex = updatedCars[carIndex].jobs.findIndex(prop => prop.jobId === job.jobId)!;

        if(propIndex >= 0){
            updatedCars[carIndex].jobs.splice(propIndex, 1, job);
        }
        else{
            if( updatedCars[carIndex].jobs == undefined){
                updatedCars[carIndex].jobs = [];
            }
            updatedCars[carIndex].jobs.push(job);
        }
        
        return updatedCars;
    }

    // Posting

    public static upsertPostingInCar = ( cars: Car[], posting: Posting ) => {
        
        let updatedCars: Car[]  = JSON.parse(JSON.stringify(cars));

        let carIndex = updatedCars.findIndex(car =>  car.carId === posting.carId)!;

        if(! (carIndex >= 0)){
            return updatedCars;
        }

        let propIndex = updatedCars[carIndex].postings.findIndex(prop => prop.postingId === posting.postingId)!;

        if(propIndex >= 0){
            updatedCars[carIndex].postings.splice(propIndex, 1, posting);
        }
        else{
            if( updatedCars[carIndex].postings == undefined){
                updatedCars[carIndex].postings = [];
            }
            updatedCars[carIndex].postings.push(posting);
        }
        
        return updatedCars;
    }

 // conversations and messages   

    
/*
    public static addMessage = ( dealer: Dealer,  newMsg: Message ) => {

        let updatedDealer: Dealer  = JSON.parse(JSON.stringify(dealer));
        
        if(updatedDealer.messages == undefined){
            updatedDealer.messages = [];
        }
        updatedDealer.messages.push(newMsg);

        return updatedDealer;
    }
*/
public static addMessageToConversationInCar = ( cars: Car[], carId: string, conversationId: number, newMsg: Message ) => {

    let updatedCars: Car[]  = JSON.parse(JSON.stringify(cars));

    let carIndex = updatedCars.findIndex(car => carId === car.carId)!;

    if(!(carIndex >=0) ){
        return updatedCars;
    }

    let convIndex = updatedCars[carIndex].conversations.findIndex(conv => conversationId === conv.id)!;
    
    updatedCars[carIndex].conversations[convIndex].messages.push(newMsg);

    return updatedCars;

}

public static addConversationInCar = ( cars: Car[],  newConv: Conversation ) => {

    let updatedCars: Car[]  = JSON.parse(JSON.stringify(cars));

    let index = updatedCars.findIndex(car => newConv.carId === car.carId)!;
    
    if(index >= 0){
        updatedCars[index].conversations.push(newConv);
        return updatedCars;
    }

    return updatedCars;
}

// messages

public static updateAllMessages = ( dealer: Dealer,  allMsgs: Message[] ) => {

    let updatedDealer: Dealer  = JSON.parse(JSON.stringify(dealer)); 
    
    if(updatedDealer.messages == undefined){
        updatedDealer.messages = [];
    }
    updatedDealer.messages = allMsgs;

    return updatedDealer;
}


// reviews

    public static updateDealerRatingsSummary = ( dealer: Dealer,  ratingsSummary: RatingsSummary ) => {

        let updatedDealer: Dealer  = JSON.parse(JSON.stringify(dealer));

        updatedDealer.ratingsSummary = ratingsSummary;

        return updatedDealer;
    }


    public static addReviewReply = ( dealer: Dealer,  reviewId: string, reply: ReviewReply ) => {

        let updatedDealer: Dealer  = JSON.parse(JSON.stringify(dealer));

        let reviewIndex: number = updatedDealer.reviews.findIndex( (rev) => rev.id === reviewId);
        
        if (updatedDealer.reviews[reviewIndex].replies == undefined){
            updatedDealer.reviews[reviewIndex].replies = [];
        }
        updatedDealer.reviews[reviewIndex].replies.push(reply);

        return updatedDealer;
    }


    public static updateMenu = ( currentMenu: {  [key: string]: number }, updates: {  [key: string]: number } ) => {

        return { ...currentMenu, ...updates };
    }

}
